import type { AppGroup } from '@/types';

export const appGroupsMock: AppGroup[] = [
    {
        id: '123456789',
        name: 'Appollo',
        appIds: ['appollo-ios', 'appollo-android', 'appollo-react-native-ota'],
        appGroupImageUrl: 'https://runway-img.s3.us-east-2.amazonaws.com/app-demo-mercury.png',
    },
    {
        id: '123456790',
        name: 'Gemini',
        appIds: ['gemini'],
        appGroupImageUrl: 'https://runway-img.s3.us-east-2.amazonaws.com/app-demo-gemini.png',
    },
    {
        id: '123456791',
        name: 'Mercury',
        appIds: ['mercury'],
        appGroupImageUrl: 'https://runway-img.s3.us-east-2.amazonaws.com/app-demo-launch.png',
    },
];
